class ShipEstimate extends HTMLElement {
  connectedCallback() {
    const target = this.querySelector('[data-ship-date]');
    const days = Number(this.dataset.days) || 4;
    if (!target) return;

    const date = new Date();
    let remaining = days;

    while (remaining > 0) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();
      if (day !== 0 && day !== 6) remaining -= 1;
    }

    target.textContent = date.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
    });
  }
}

if (!customElements.get('ship-estimate')) {
  customElements.define('ship-estimate', ShipEstimate);
}
